import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/opusflow.webp';
import screenshot_target from '../../../images/letterfunnel/diegosmits.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Diego Smits"
      firstname="Diego"
      companyname="OpusFlow"
      competition="Sollit en Solar Monkey"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/diegosmits.js